// extracted by mini-css-extract-plugin
export default {"wrapper":"Devices_wrapper__FPtk-"};